export const BukMountainlocation = [
  {latitude:37.712773, hardness:126.970967},
  {latitude:37.701654, hardness:126.968624},
  {latitude:37.687111, hardness:126.961417},
  {latitude:37.678572, hardness:126.958271},
  {latitude:37.668060, hardness:126.952737},
  {latitude:37.657605, hardness:126.942703},
  {latitude:37.649828, hardness:126.937869},
  {latitude:37.643778, hardness:126.939585},
  {latitude:37.637864, hardness:126.940533},
  {latitude:37.634772, hardness:126.933635},
  {latitude:37.629824, hardness:126.934741},
  {latitude:37.624361, hardness:126.936889},
  {latitude:37.620288, hardness:126.934025},
  {latitude:37.614051, hardness:126.937540},
  {latitude:37.613174, hardness:126.944959},
  {latitude:37.609669, hardness:126.942030},
  {latitude:37.606039, hardness:126.938352},
  {latitude:37.598533, hardness:126.939260},
  {latitude:37.593768, hardness:126.942332},
  {latitude:37.593974, hardness:126.943846},
  {latitude:37.596819, hardness:126.944149},
  {latitude:37.601960, hardness:126.942764},
  {latitude:37.603537, hardness:126.946571},
  {latitude:37.602458, hardness:126.944752},
  {latitude:37.603524, hardness:126.946668},
  {latitude:37.605480, hardness:126.948508},
  {latitude:37.607295, hardness:126.950799},
  {latitude:37.610612, hardness:126.954593},
  {latitude:37.617389, hardness:126.953448},
  {latitude:37.614463, hardness:126.965415},
  {latitude:37.615524, hardness:126.972564},
  {latitude:37.616498, hardness:126.979377},
  {latitude:37.613224, hardness:126.981499},
  {latitude:37.611543, hardness:126.979265},
  {latitude:37.611669, hardness:126.991716},
  {latitude:37.613703, hardness:126.994520},
  {latitude:37.610628, hardness:126.996181},
  {latitude:37.612907, hardness:126.998941},
  {latitude:37.614331, hardness:126.996951},
  {latitude:37.615368, hardness:126.999586},
  {latitude:37.618652, hardness:126.997959},
  {latitude:37.620374, hardness:126.998757},
  {latitude:37.619367, hardness:126.998713},
  {latitude:37.619471, hardness:127.000510},
  {latitude:37.618534, hardness:127.001650},
  {latitude:37.619098, hardness:127.002153},
  {latitude:37.620270, hardness:127.001296},
  {latitude:37.621874, hardness:127.002131},
  {latitude:37.618898, hardness:127.002799},
  {latitude:37.619096, hardness:127.003947},
  {latitude:37.620407, hardness:127.004290},
  {latitude:37.620863, hardness:127.005361},
  {latitude:37.621793, hardness:127.006040},
  {latitude:37.622576, hardness:127.005175},
  {latitude:37.622625, hardness:127.005752},
  {latitude:37.622038, hardness:127.007111},
  {latitude:37.622674, hardness:127.008408},
  {latitude:37.622160, hardness:127.009458},
  {latitude:37.623096, hardness:127.010294},
  {latitude:37.623712, hardness:127.011438},
  {latitude:37.627047, hardness:127.010375},
  {latitude:37.627856, hardness:127.008740},
  {latitude:37.628730, hardness:127.011684},
  {latitude:37.630123, hardness:127.011356},
  {latitude:37.630562, hardness:127.009120},
  {latitude:37.633743, hardness:127.008685},
  {latitude:37.638816, hardness:127.005211},
  {latitude:37.639762, hardness:127.007491},
  {latitude:37.641998, hardness:127.007382},
  {latitude:37.642771, hardness:127.003256},
  {latitude:37.647500, hardness:127.003582},
  {latitude:37.647242, hardness:127.007382},
  {latitude:37.649649, hardness:127.010857},
  {latitude:37.654574, hardness:127.007817},
  {latitude:37.655709, hardness:127.009967},
  {latitude:37.660410, hardness:127.010479},
  {latitude:37.661625, hardness:127.015291},
  {latitude:37.657411, hardness:127.018669},
  {latitude:37.676374, hardness:127.042625},
  {latitude:37.687393, hardness:127.038940},
  {latitude:37.709264, hardness:127.040066},
  {latitude:37.732910, hardness:127.032183},
  {latitude:37.739351, hardness:127.020614},
  {latitude:37.729353, hardness:126.994885},
  {latitude:37.719707, hardness:126.979864},
  {latitude:37.714055, hardness:126.973269},
];